import CoreButtonBase from './ButtonBase';

import { ButtonProps } from '../interfaces/';

/**
 * Default Button
 * @export
 * @class CoreDefaultButton
 * @extends {CoreButtonBase<Component<ButtonProps, ButtonState>>}
 */
export default class CoreDefaultButton extends CoreButtonBase {
  public static defaultProps: ButtonProps = {
    type: 'button',
    variant: 'default',
    outline: true
  };
}
